// extracted by mini-css-extract-plugin
export var number = "UgEeRnfnu_HF0rdk82Vs";